import { ApolloProvider } from '@apollo/client';
import { MotionLazyContainer } from '@bakerweb/components';
import { gqlPublic } from '@bakerweb/public-services';
import { CollapseDrawerProvider, SettingsProvider } from '@bakerweb/theme';
import { ScrollToTop } from '@bakerweb/utils-ui';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
import { App } from './app/App';

const container = document.getElementById('root');
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const root = createRoot(container);
root.render(
  <StrictMode>
    <HelmetProvider>
      <SettingsProvider
        theme={{
          themeMode: 'light',
          themeDirection: 'ltr',
          themeColor: 'blue',
          themeStretch: true,
          chartTheme: 'current'
        }}
      >
        <CollapseDrawerProvider>
          <BrowserRouter>
            <ScrollToTop />
            <MotionLazyContainer>
              <ApolloProvider client={gqlPublic}>
                <App />
              </ApolloProvider>
            </MotionLazyContainer>
          </BrowserRouter>
        </CollapseDrawerProvider>
      </SettingsProvider>
    </HelmetProvider>
  </StrictMode>
);
